import { ReactNode } from 'react';
import { toast, ToastOptions } from 'react-hot-toast/headless';

import { AlertToast } from '@/components/shared/AlertToast';
import { ToastColor } from '@/components/shared/AlertToast/types';

type AlertAction = { label: string; onClick: () => void };

type ActionAlertOptions = ToastOptions & {
  description?: string;
  action: AlertAction;
  icon?: ReactNode;
};

const alertGenerator =
  (color: ToastColor) => (message: string, options?: ToastOptions) => {
    toast.remove();
    return toast.custom(
      () => (
        <AlertToast color={color}>
          <AlertToast.Icon color={color} />
          <AlertToast.Message>{message}</AlertToast.Message>
        </AlertToast>
      ),
      options,
    );
  };

const alert = (message: string, opts?: ToastOptions) =>
  alertGenerator('success')(message, opts);

alert.success = alertGenerator('success');
alert.error = alertGenerator('error');
alert.warning = alertGenerator('warning');
alert.info = alertGenerator('info');

alert.action = (
  title: string,
  { description, action, icon, ...options }: ActionAlertOptions,
) => {
  toast.remove();
  return toast.custom(
    t => (
      <AlertToast>
        <AlertToast.Icon>{icon}</AlertToast.Icon>
        <AlertToast.Content title={title} description={description} />
        <AlertToast.Action
          label={action.label}
          onClick={() => {
            action.onClick();
            toast.dismiss(t.id);
          }}
        />
      </AlertToast>
    ),
    options,
  );
};

export default alert;
